import React from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/Form.css';
import logo from '../assets/images/Logo.svg';
import { useForm } from './hooks/useForm';
import { map } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { ReqPost } from '../config/Requests';
import { useDispatch, useSelector } from 'react-redux';
import { signupUser } from '../store/signup/async-actions';
import { toast } from 'react-toastify';

function JoinMember(props) {
	let navigate = useNavigate();
	const dispatch = useDispatch();

	const signupUser = values => dispatch(signupUser(values));

	const gettokenFromPath = pathName => pathName.split('/').reverse()[0];

	const issignup = useSelector(state => state.signup.isSuccess);
	const token = useSelector(state =>
		gettokenFromPath(state.router.location.pathname)
	);
	const [values, handleChange] = useForm({
		name: '',
		password: '',
		password_confirmation: '',
		token: token,
	});
	console.log(values.token);
	const handleSubmit = e => {
		e.preventDefault();
		ReqPost('join-member', values)
			.then(res => {
				navigate(`/login`);
			})
			.catch(err => {
				const { data } = err.response;
				const keys = Object.keys(data);
				map(keys, k => map(data[k], c => toast.error(c)));
			});
	};

	return (
		<div className='main-container form-bg-color form-bg-reg'>
			<img src={logo} className='form-logo' alt='logo' />
			{alert.length !== 0 ? alert : ''}
			<div className='form-container'>
				<div className='form-label-header'>Join Member</div>
				<form className='reg-form' onSubmit={handleSubmit}>
					<input
						className='form-input'
						type='text'
						id='name'
						name='name'
						value={values.name}
						onChange={handleChange}
						placeholder='Full name'
						required
					/>
					<input
						className='form-input'
						type='password'
						id='password'
						name='password'
						value={values.password}
						onChange={handleChange}
						placeholder='Password'
						required
					/>
					<input
						className='form-input'
						type='password'
						id='password_confirmation'
						name='password_confirmation'
						value={values.password_confirmation}
						onChange={handleChange}
						placeholder='Confirm Password'
						required
					/>

					<button type='submit' className='btn-signup'>
						JOIN COGEN
					</button>

					<span className='text-link-to'>
						Already A Member?{' '}
						<Link to='/login' className='btn-link'>
							<strong>Log In</strong>
						</Link>{' '}
					</span>
				</form>
			</div>
		</div>
	);
}

export default JoinMember;
